import bgImage from './bgImage.js'
import global from './global.js'

export default {
  install: (Vue) => {
    Vue.directive('parallax', global)
    Vue.directive('bg-parallax', bgImage)
  },
}
